import {DataViz} from '../../../service/DataViz'

const readStyleFromSession = async (styleType = 'cluster') => {
  return new Promise((resolve, reject) => {
    try {
      const res = {
        data: featureLayer.Style.GetStyle(styleType),
        status: 200
      }
      resolve(res)
    } catch (e) {
      reject(e)
    }
  })
}

const getCompositeStyle = async ({ commit }, layerUid) => {
  const backEnd = DataViz.build({})
  try {
    const res = await backEnd.getCompositeStyle(layerUid)
    return res.data
  } catch (e) {
    throw e
  }
}
const loadBorderStyle = async ({ getters, commit }, layerId) => {
  try {
    const featureLayer = getters.getLayer(layerId)
    const hexMode = featureLayer.IsHexagon
    const layerType = hexMode ? 'fill' : featureLayer.GetLayerType()
    if (layerType !== 'fill') return false
    const tagStyle = hexMode ? 'hb' : 'line'
    const hasStyle = featureLayer.Style.GetStyle(tagStyle, true) !== null
    const promises = [hasStyle ? await readStyleFromSession(tagStyle) : await this.readStyleFromServer(tagStyle)]
    await Promise.all(promises).then(async (results) => {
      const res = results[0]
      if (res.status === 200) {
        const style = res.data
        style.type = 'line'
        if (!hasStyle) {
          featureLayer.Style.SetStyle(tagStyle, style)
        }
        commit('syncBorderStyle', style)
      }
    })
  } catch (e) {
    throw e
  }
}
//const loadColorStyle = async ({ getters, commit, context }, layerId) => {
const loadColorStyle = async (context, layerId) => {
  try {
    const featureLayer = context.getters['map/getLayer'](layerId)
    const self = this
    const layerType = featureLayer.IsHexagon ? 'hexagon' : featureLayer.HasSymbol ? 'circle' : featureLayer.GetLayerType()
    let tagStyle = featureLayer.Table.AnyFilter() && !featureLayer.IsAggregated && !featureLayer.IsHexagon ? featureLayer.HasSymbol ? 'circle' : 'filter' : layerType
    const hasStyle = featureLayer.Style.GetStyle(tagStyle, true) !== null
    const promises = [hasStyle ? await readStyleFromSession(tagStyle) : await this.readStyleFromServer(tagStyle)]
    await Promise.all(promises).then(async (results) => {
      const res = results[0]
      if (res.status === 204) {
        return false
      } else if (res.status >= 200 && res.status < 300) {
        const style = res.data
        const hasSymbolStyle = Object.keys(style.paint).some(x => x.startsWith('icon'))

        if (!hasStyle) {
          featureLayer.Style.SetStyle(tagStyle, style)
        }

        const lyrType = hasSymbolStyle ? 'symbol' : layerType
        context.commit('style/syncColorStyle', {lyrType, style})
      }
    })
  } catch (e) {
    throw e
  }
}
const setCircleBlur = ({ commit }, value) => {
  commit('setCircleBlur', value)
}
const setCustomColor = ({ commit }, payload) => {
  commit('setCustomColor', payload)
}
const setFillColor = ({ commit }, value) => {
  commit('setFillColor', value)
}
const setFillOpacity = ({ commit }, value) => {
  commit('setFillOpacity', value)
}

export default {
  getCompositeStyle,
  loadBorderStyle,
  loadColorStyle,
  setCircleBlur,
  setCustomColor,
  setFillColor,
  setFillOpacity
}
